import { render } from "./HeaderNav.vue?vue&type=template&id=04dabf2d&scoped=true"
import script from "./HeaderNav.vue?vue&type=script&lang=js"
export * from "./HeaderNav.vue?vue&type=script&lang=js"

import "./HeaderNav.vue?vue&type=style&index=0&id=04dabf2d&lang=scss"
import "./HeaderNav.vue?vue&type=style&index=1&id=04dabf2d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.44_vue@3.5.44_webpack@5.112.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04dabf2d"]])

export default __exports__